import React from 'react';
import './Pagination.css';
import CustomDropdown from '../utils/customDropdown';

const Pagination = ({ page, totalPages, totalResults, limit, onPageChange }) => {
  const pageNumbers = [];

  // ✅ New Pagination Logic (only 3 visible pages)
  const maxVisible = 3;
  let startPage = Math.max(1, page - Math.floor(maxVisible / 2));
  let endPage = startPage + maxVisible - 1;

  if (endPage > totalPages) {
    endPage = totalPages;
    startPage = Math.max(1, endPage - maxVisible + 1);
  }

  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  if (startPage > 1) pageNumbers.unshift('...');
  if (endPage < totalPages) pageNumbers.push('...');

  const start = (page - 1) * limit + 1;
  const end = Math.min(page * limit, totalResults);

  const pageOptions = Array.from({ length: totalPages }, (_, i) => ({
    value: i + 1,
    label: i + 1,
  }));

  return (
    <div className="pagination-container">
      <span className="pagination-info">
        Viewing {end - start + 1} from {totalResults} results
      </span>
      <div className="pagination-controls">
        <div className="count-pages">
          <button onClick={() => onPageChange(1)} disabled={page === 1}>
            &laquo;
          </button>
          <button onClick={() => onPageChange(page - 1)} disabled={page === 1}>
            &lsaquo;
          </button>

          {pageNumbers.map((num, idx) =>
            num === "..." ? (
              <span key={idx} className="pagination-ellipsis">...</span>
            ) : (
              <button
                key={idx}
                className={num === page ? "active" : ""}
                onClick={() => onPageChange(num)}
              >
                {num}
              </button>
            )
          )}

          <button onClick={() => onPageChange(page + 1)} disabled={page === totalPages}>
            &rsaquo;
          </button>
          <button onClick={() => onPageChange(totalPages)} disabled={page === totalPages}>
            &raquo;
          </button>
        </div>

        <div className="pagination-page-select">
          Page
          <CustomDropdown
            options={pageOptions}
            selectedValue={page}
            onSelect={(value) => onPageChange(value)}
          />
          of {totalPages}
        </div>
      </div>
    </div>
  );
};


export default Pagination;
